<template>
    <div class="calculadora calculadora-pesoideal">
      <div class="row">
          <div class="col-md-4">
              <h3 class="pi-titulo">{{ strings.instructions.title }}</h3>
              <div class="pi-instrucoes">
                  {{ strings.instructions.description }}
                  <span class="pi-titulo mt-3">{{ strings.instructions.subtitle }}</span>
                  <strong>{{ strings.instructions.masc.title }} </strong> {{ strings.instructions.masc.instruction }} <br /><br />
                  <strong>{{ strings.instructions.fem.title }} </strong> {{ strings.instructions.fem.instruction }} <br /><br />
                  <strong>{{ strings.instructions.adjusted.title }} </strong> {{ strings.instructions.adjusted.instruction }}
              </div>
          </div>
          <form @submit.prevent="calculate()" class="col-md-4" onload="this.reset()">
              <span class="pi-titulo">{{ strings.form.title }}</span>
              <div class="form-group">
                <div class="placeholder">{{ strings.form.fields.weight.title }}</div>
                  <input  @input="showResults = false" id="fld-pi-peso" class="form-control" v-model="peso" type="number" min="1" max="500" step="1" :placeholder="strings.form.fields.weight.placeholder" />
                  <label for="fld-pi-peso">{{ strings.form.fields.weight.desc }}</label>
              </div>
              <div class="form-group">
                <div class="placeholder">{{ strings.form.fields.height.title }}</div>
                  <input  @input="showResults = false" id="fld-pi-altura" class="form-control" v-model="altura" type="number" min="1" max="250" step="1" :placeholder="strings.form.fields.height.placeholder" />
                  <label for="fld-pi-altura">{{ strings.form.fields.height.desc }}</label>
              </div>
              <div class="form-group">
                  <label>{{ strings.form.fields.gender.title }}</label>

                  <div class="horizontal-inputs">
                      <label for="fld-pi-sexo-m" class="eurofarma-radio-input" :class="{selected: sexo === 'M'}">
                          <input @input="showResults = false" id="fld-pi-sexo-m" name="pi_sexo" v-model="sexo" value="M" type="radio" />
                          {{ strings.instructions.masc.title }}
                      </label>

                      <label for="fld-pi-sexo-f" class="eurofarma-radio-input" :class="{selected: sexo === 'F'}">
                          <input @input="showResults = false" id="fld-pi-sexo-f" name="pi_sexo" v-model="sexo" value="F" type="radio" />
                          {{ strings.instructions.fem.title }}
                      </label>
                  </div>
              </div>
              <div class="form-group">
                  <button type="submit" class="btn btn-primary">{{ strings.form.calculate }}</button>
              </div>
          </form>
          <div class="col-md-4">
              <div v-if="showResults">
                  <div class="results-row">
                      <div class="pi-resultado">
                          <span>{{ strings.result.ideal }}</span>
                          <strong>{{pesoIdeal.toFixed(1)}} kg</strong>
                      </div>

                      <div class="pi-resultado">
                          <span>{{ strings.result.adjusted }}</span>
                          <strong>{{pesoIdealAjustado.toFixed(1)}} kg</strong>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>
<script>
    export default {

        props: {
            strings: Object
        },

        data: () => { return {
            peso: '',
            altura: '',
            sexo: 'M',
            showResults: false,
            infoInvalid: false,
        }},

        computed: {
            pesoIdeal: function() {

              let returnInfo = 0;

                if (this.sexo === 'F') {
                  returnInfo = 52 + (0.75 * (this.altura - 152.4));
                }else {
                  returnInfo = 49 + (0.67 * (this.altura - 152.4));
                }

                if(returnInfo < 0) {
                  this.showResults = false;
                  this.infoInvalid = true;
                }

              return returnInfo;
            },

            pesoIdealAjustado: function() {
                return ((this.peso - this.pesoIdeal) * 0.25) + this.pesoIdeal;
            },
        },

        methods: {
            calculate: function() {
                this.showResults = true;
            }
        }
    }
</script>
